import { createFileRoute } from "@tanstack/react-router";
import { configuratorRouteLoader } from "../../../$productCode/configuratorPage/-configuratorLoader";
import { ConfiguratorRoute } from "../../../$productCode/configuratorPage/-configuratorShared";

export const Route = createFileRoute("/shaft/$productCode/shaftConfiguratorPage/LinearConfigurator")({
  loader: configuratorRouteLoader,
  component: ConfiguratorRoute,
});
